var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"https://www.hilton.com.cn/global_footer/logo_footer_cn.html","width":"100%","height":"208px","frameborder":"no"}})}
var staticRenderFns = []

export { render, staticRenderFns }